var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      staticClass: "staff-member-modal",
      attrs: { closable: false },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("sui-icon", {
        attrs: { name: "close" },
        on: { click: _vm.handleCloseModal },
      }),
      _c(
        "sui-modal-header",
        { attrs: { align: "center" } },
        [
          _c(
            "sui-header",
            { tag: "h3", attrs: { icon: "", "text-align": "center" } },
            [
              _c("sui-icon", { attrs: { name: "user", circular: "" } }),
              _c("sui-header-content", [
                _vm._v(_vm._s(_vm.modalHeaderContent)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-modal-content",
        [
          _c("MasterForm", {
            ref: "memberForm",
            attrs: {
              "is-new": _vm.isNew,
              staffMember: _vm.staffMember,
              "toggle-modal": _vm.toggleModal,
              "reset-is-new": _vm.resetIsNew,
            },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.handleCancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { click: _vm.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }